import * as http from '~/utils/apis';

const characterClassApi = {
    getAll: async () => {
        const res = await http.get(`cms-api/dashboard/characterClass`);
        return res;
    },
};

export default characterClassApi;
